import InstalarCorvana from "../../../shared/components/InstalarCorvana";

/** /portal/app — instalar Corvana en el celular o mandar el link a la familia. */
export default function PortalApp() {
  return (
    <div style={{ padding: "28px 20px 48px", maxWidth: 620 }}>
      <InstalarCorvana modo="pagina" condominio={localStorage.getItem("condominio_nombre") || ""} />
    </div>
  );
}
